module.exports = __webpack_public_path__ + "img/icon-download.d4fc8812.svg";